const language = {
	spanish: {
		header_title: "Usuario ",
		header_span_title: "Final",
		usuario_yellow_title: "Usuario Final",
		usuario_bold_title:
			"Es cierto que Foresight GPS tiene como foco estratégico los clientes corporativos, no obstante nuestras soluciones tienen aplicaciones concretas para usuarios finales.",
		usuario_bold_text:
			"De modo que si desea adquirir un servicio de rastreo profesional y de alta precisión para su flota familiar o negocio estamos atentos a escuchar su requerimiento y lo orientaremos de la mejor manera para satisfacer sus necesidad de seguridad y/o logística.",
		usuario_bold_text_2: "Beneficios de nuestra plataforma",
		usuario_list: [
			"Creación de áreas de seguridad y alertas de entrada y salida de estas áreas",
			"Alertas de seguridad desde en dispositivos discretos o vía aplicación móvil",
			"Rastreo en tiempo real de personas sobre mapas digitales",
			"Desarrollo marca blanca dependiendo de las necesidades",
			"Lleve el control de su activo desde una aplicación móvil o la web",
			"Soporte de servicio 24/7",
		],
		localizacion_yellow_title: "Localización de personas y objetos",
		localizacion_bold_text:
			"Con un pequeño dispositivo y una plataforma de última generación, puedes visualizar sobre mapas digitalizados y fotos satelitales la localización de tus hijos o seres queridos en tiempo real.",
		prevencion_yellow_title: "Previene pérdida de activos",
		prevencion_bold_title:
			"En tiempo real con visibilidad remota y recepción de alertas, podrás saber si tu activo es movido del lugar sin autorización.",
		prevencion_bold_text: "Características:",
		prevencion_list: [
			"Historial de recorridos por cada persona",
			"Sistema de localización GPS y vía aplicación móvil",
			"Alertas en tiempo real, si el dispositivo sale o entra de un área predeterminada",
			"Batería de larga duración con autonomía mayor a 4 días (para dispositivos independientes)",
			"Botón de pánico (SOS) que lanza una alerta al teléfono particular asociado o un SOS desde una aplicación móvil",
			"Dispositivos versátil y pequeños",
			"No requiere instalación",
		],
	},
	english: {
		header_title: "End ",
		header_span_title: "User",
		usuario_yellow_title: "End User",
		usuario_bold_title:
			"It is true that Foresight GPS has corporate clients as a strategic focus, however our solutions have specific applications for end users.",
		usuario_bold_text:
			"So if you want to acquire a professional and high precision tracking service for your family or business fleet, we are attentive to listen to your request and we will guide you in the best way to satisfy your security and / or logistics needs.",
		usuario_bold_text_2: "Benefits of our platform",
		usuario_list: [
			"Creation of security areas and alerts of entry and exit of these areas",
			"Security alerts from discrete devices or via mobile application",
			"Real-time tracking of people on digital maps",
			"White label development depending on the needs",
			"Take control of your asset from a mobile application or the web",
			"24/7 service support",
		],
		localizacion_yellow_title: "Location of people and objects",
		localizacion_bold_text:
			"With a small device and a last generation platform, you can visualize on digitized maps and satellite photos the location of your children or loved ones in real time.",
		prevencion_yellow_title: "Prevents loss of assets",
		prevencion_bold_title:
			"In real time with remote visibility and receipt of alerts, you will be able to know if your asset is moved from the place without authorization.",
		prevencion_bold_text: "Features:",
		prevencion_list: [
			"Tour history for each person",
			"GPS location system and via mobile application",
			"Real-time alerts, if the device leaves or enters a predetermined area",
			"Long-lasting battery with autonomy greater than 4 days (for independent devices)",
			"Panic button (SOS) that launches an alert to the associated home phone or an SOS from a mobile application",
			"Versatile and small devices",
			"No installation required",
		],
	},
};

export default language;